import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { buildScopeTranslate } from "lib/I18n";

const tLeave = buildScopeTranslate("views.content.assessment_framework.assessments.pages.leave_modal");

const LeaveAssessmentModal = ({ open, onStay, onLeave }) => {
  const modalRef = useRef(null);

  // The tds-modal close (X) button and escape key emit "requestclose" — both are
  // equivalent to "Keep Going" (dismiss and stay on the assessment).
  useEffect(() => {
    const modal = modalRef.current;
    if (modal) {
      modal.addEventListener("requestclose", onStay);
      return () => {
        modal.removeEventListener("requestclose", onStay);
      };
    }
    return undefined;
  }, [onStay]);

  return (
    <tds-modal
      ref={modalRef}
      open={open}
      assistive-text={tLeave("title")}
      class="th-agentforce-assessment__leave-modal">
      <div slot="heading" className="slds-text-heading_medium" tabIndex="0">
        {tLeave("title")}
      </div>

      <div slot="content">
        <p className="slds-text-body_regular">
          {tLeave("body")}
        </p>
      </div>

      <div slot="footer" className="th-agentforce-assessment__modal-footer">
        <tds-button onClick={onStay}>
          <span>{tLeave("keep_going")}</span>
        </tds-button>
        <tds-button variant="destructive" onClick={onLeave}>
          <span>{tLeave("leave")}</span>
        </tds-button>
      </div>
    </tds-modal>
  );
};

LeaveAssessmentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onStay: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
};

export default LeaveAssessmentModal;
